<template>
  <v-container class="mt-14 pa-0 sales-container" fluid>
    <!-- ===== Floating Left Tab (shown after popup is closed) ===== -->
    <transition name="slide-tab">
      <button
        v-if="
          !announcementStore.showModal &&
          announcementStore.publishedAnnouncements.length > 0
        "
        class="announcement-tab"
        @click="announcementStore.openModal()"
      >
        <v-icon size="16" color="white">mdi-bullhorn</v-icon>
        <span>Announcement</span>
      </button>
    </transition>

    <!-- Announcements Modal is now global in TopNavbar.vue -->

    <div class="cards-grid mt-12">
      <cardComp v-for="card in cards_data" :key="card.id" :card="card" />
    </div>

    <!-- <v-row class="home-details bg-white" v-if="homePageStore.homeData">
      <v-col cols="12">
        <h2 class="header-title">Key Performance Indicators</h2>
      </v-col>
      <v-col cols="12" md="4" lg="4" sm="6">
        <v-card class="ach-card">
          <div class="card-header d-flex justify-space-between">
            <h2>Total Revenue</h2>
            <div class="icon">
              <img src="@/assets/images/layout/sar-white.svg" alt="" />
            </div>
          </div>
          <div class="card-body">
            <div class="values d-flex align-center mb-4">
              <img
                width="48"
                height="48"
                src="@/assets/images/layout/48 PX.svg"
                alt="sar icon"
              />
              <span>
                <p>{{ formatNumber(kpi.total_revenue) }}</p>
              </span>
            </div>
            <div class="persentage d-flex ga-2 align-center">
              <img
                width="16"
                height="16"
                src="@/assets/images/layout/gray-upgrade.svg"
                alt="up-grade"
              />
              <span>{{ kpi.fy_achievement?.percentage }}%</span>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4" sm="6">
        <YTDAchievement
          :totalValue="kpi.fy_achievement?.value"
          :percentage="kpi.fy_achievement?.percentage"
          :target="kpi.fy_achievement?.target"
          :title="'FY Achievement'"
          :subTitle="'Total value of FY Ach'"
          :targetTitle="'FY Target'"
        />
      </v-col>

      <v-col cols="12" md="6" lg="4" sm="6">
        <YTDAchievement
          :totalValue="kpi.ytd_achievement?.value"
          :percentage="kpi.ytd_achievement?.percentage"
          :target="kpi.ytd_achievement?.target"
          :title="'YTD Achievement'"
          :subTitle="'Total value of YTD Ach'"
          :targetTitle="'YTD Target'"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="6"
        class="mt-7"
        v-for="card in backOrderCards"
        :key="card.id"
      >
        <mainCard :card="card" />
      </v-col>

      <v-col cols="12" md="4" lg="4" sm="6" class="mt-7">
        <ExpiryRiskValue
          :totalValue="kpi.expiry_risk_value"
          :percentage="0"
          :title="'Expiry Risk Value'"
        />
      </v-col>
    </v-row> -->

    <!-- <v-row class="bg-white pt-12 px-15">
      <v-col cols="12">
        <h2 class="header-title">Allurion Statistics</h2>
      </v-col>
      <v-col
        v-for="card in allurion_statistics_cards"
        :key="card.id"
        cols="12"
        md="4"
        lg="4"
        sm="6"
        class="mt-7"
      >
        <mainCard :card="card" />
      </v-col>
    </v-row> -->
    <!-- <v-row class="bg-white pt-12 px-15">
      <v-col cols="12">
        <EventsCalendar
          :range="marktingStore.eventsData.calendar.range"
          :days="marktingStore.eventsData.calendar.days"
        />
      </v-col>
    </v-row>

    <v-row class="bg-white pt-12 px-15">
      <v-col cols="12">
        <h2 class="header-title">Forecast Tracking</h2>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <mainCard :card="fcts_card" />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <fctsProgress :item="fcstProgressItem" />
      </v-col>
    </v-row> -->

    <!-- <v-row class="bg-white pt-12 px-15">
      <v-col cols="12" class="header-title">
        <h2 class="header-title">Consignment Capacity</h2>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <totalConsignmentsValue />
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <div class="consignment-card bg-white">
          <h3 class="title">Consignment Aging</h3>
          <v-chart class="chart" :option="option" autoresize />
          <div class="legend-grid">
            <div v-for="(item, i) in chartData" :key="i" class="legend-item">
              <span class="dot" :style="{ backgroundColor: colors[i] }"></span>
              <span class="label">{{ item.name }}</span>
              <span class="value">{{ formatNumber(item.value) }}</span>
            </div>
          </div>
        </div>
      </v-col>
    </v-row> -->

    <!-- <v-row class="bg-white pt-12 px-15" v-if="homePageStore.homeData">
      <v-col cols="12" class="header-title">
        <h2 class="header-title">Achievement Analysis</h2>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <salesPerSupplier
          title="Sales Per Supplier"
          :items="
            homeData.achievement_analysis?.sales_per_supplier?.map((s) => ({
              name: s.vendor_name,
              value: s.value,
            }))
          "
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <salesPerSupplier
          :title="'Sales Per Area'"
          :items="SalesPerAreaItems"
        />
      </v-col>

      <v-col cols="12" md="6" lg="6" sm="6" class="mt-10">
        <barChartsAchiv
          :SalesSupplierItems="stackedChartItems"
          :values="stackedChartValues"
        />
      </v-col>
      <v-col cols="12" md="6" lg="6" sm="6" class="mt-10">
        <SalesTimelineChart
          :seriesMeta="timelineSeriesMeta"
          :dataSets="timelineDataSets"
        />
      </v-col>

      <v-col cols="12" md="6" lg="6" sm="12" class="mt-10">
        <EChartsComponent
          title="W/S Ach"
          :percentage="statistics.ws_achievement?.percentage"
          :target="statistics.ws_achievement?.target"
          :sales="statistics.ws_achievement?.sales"
          :vendors="statistics.ws_achievement?.vendors"
        />
      </v-col>

      <v-col cols="12" md="6" lg="6" sm="12" class="mt-10">
        <EChartsComponent
          title="C/E Ach"
          :percentage="statistics.ce_achievement?.percentage"
          :target="statistics.ce_achievement?.target"
          :sales="statistics.ce_achievement?.sales"
          :vendors="statistics.ce_achievement?.vendors"
        />
      </v-col>

      <v-col cols="12" md="6" lg="6" sm="12" class="mt-10">
        <achPerPs
          title="W/S ACH per PS"
          :categories="statistics.ws_ach_per_ps?.map((p) => p.ps_name)"
          :targetData="statistics.ws_ach_per_ps?.map((p) => p.target)"
          :salesData="statistics.ws_ach_per_ps?.map((p) => p.sales)"
        />
      </v-col>

      <v-col cols="12" md="6" lg="6" sm="12" class="mt-10">
        <achPerPs
          title="C/E ACH per PS"
          :categories="statistics.ce_ach_per_ps?.map((p) => p.ps_name)"
          :targetData="statistics.ce_ach_per_ps?.map((p) => p.target)"
          :salesData="statistics.ce_ach_per_ps?.map((p) => p.sales)"
        />
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
// import VChart from "vue-echarts";
// import * as echarts from "echarts/core";
// import { PieChart } from "echarts/charts";
// import { CanvasRenderer } from "echarts/renderers";

import cardComp from "../components/homePage/cardComp.vue";
import { useHomePageStore } from "../stores/homePageStore";
import { useAnnouncementStore } from "@/stores/announcements";
import { useAuthStore } from "@/stores/auth";
// import YTDAchievement from "@/components/achievement/YTDAchievement.vue";
// import ExpiryRiskValue from "@/components/homePage/ExpiryRiskValue.vue";
// import mainCard from "@/components/globalComp/mainCard.vue";
// import fctsProgress from "@/components/fcts/fctsProgress.vue";
// import totalConsignmentsValue from "@/components/consigment/totalConsignmentsValue.vue";
// import salesCardIcon from "@/assets/images/layout/sales-card-icon.svg";
// import upGrade from "@/assets/images/layout/up-grade.svg";
// import storage from "@/assets/images/layout/storage.svg";
// import dark_package from "@/assets/images/layout/dark_package.svg";
// import fctsIcon from "@/assets/images/layout/facts-page-icon.svg";
// import apiClient from "@/core/buildRequest";
// import salesPerSupplier from "@/components/achievement/SalesPerSupplier.vue";
// import barChartsAchiv from "@/components/achievement/barChartsAchiv.vue";
// import SalesTimelineChart from "@/components/achievement/SalesTimelineChart.vue";
// import EChartsComponent from "@/components/achievement/EChartsComponent.vue";
// import achPerPs from "@/components/achievement/achPerPs.vue";
// import EventsCalendar from "@/components/marketing/EventsCalendar.vue";
// import { useConsignmentStore } from "@/stores/consignment";
// import { useMarktingStore } from "@/stores/markting/marktingStore";
// import { useHomePageStore } from "@/stores/homePage";

export default {
  name: "HomeView",

  components: {
    cardComp,
  },

  data() {
    return {
      homePageStore: useHomePageStore(),
      announcementStore: useAnnouncementStore(),
      colors: ["#7FE47E", "#9FCCFF", "#FFEB3A", "#FF718B"],
      agingLabels: {
        goods: "<90 days",
        normal: "91–180 days",
        mid: "181–360 days",
        old: ">360 days",
      },
      // ... other data
      backOrderCards: [],
    };
  },

  mounted() {
    // Announcements fetching is now handled globally by TopNavbar via store
  },

  methods: {
    // Announcements methods removed - handled globally
  },

  computed: {
    todayFormatted() {
      return new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    homeData() {
      return this.homePageStore.homeData || {};
    },
    kpi() {
      return this.homeData.kpi || {};
    },
    cards_data() {
      const auth = useAuthStore();
      const role = auth.user?.role?.toLowerCase();
      const isUser = role === "user";

      return this.homePageStore.cards_data.map((card) => {
        if (card.title === "Purchasing" && isUser) {
          return { ...card, disabled: true };
        }
        return card;
      });
    },
  },
};
</script>

<style>
/* ===== Announcement Tab ===== */
.announcement-tab {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  background: #00363f;
  color: white;
  border: none;
  border-radius: 0 12px 12px 0;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;
}
.announcement-tab:hover {
  background: #005060;
}
.announcement-tab span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Transition for the tab */
.slide-tab-enter-active,
.slide-tab-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-tab-enter-from,
.slide-tab-leave-to {
  transform: translateY(-50%) translateX(-100%);
  opacity: 0;
}

/* ===== Announcement Popup Card ===== */
.announce-card {
  overflow: hidden;
  border: 1px solid #eef0f2;
}
.announce-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(180deg, #fff 0%, #f9fbfc 100%);
}
.announce-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.announce-icon-wrap {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00363f, #00a896);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.announce-label {
  font-weight: 700;
  font-size: 15px;
  color: #00363f;
}
.announce-date {
  font-size: 11px;
  color: #708083;
  margin-top: 1px;
}
.announce-body {
  padding: 24px 24px 20px;
}
.announce-title {
  font-size: 20px;
  font-weight: 700;
  color: #01252b;
  margin-bottom: 10px;
}
.announce-text {
  font-size: 14px;
  color: #596a6d;
  line-height: 1.7;
  margin-bottom: 20px;
}
.announce-highlights {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.announce-hl-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0fafa;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: #01252b;
  font-weight: 500;
}
.announce-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
}

/* ===== General ===== */
.header-title {
  font-size: 24px;
  font-weight: 700;
  color: #0b3b41;
}
.home-details {
  padding: 60px 48px;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(140px, 280px));
  column-gap: 20px;
  row-gap: 100px;
  justify-content: center;
  align-items: start;
  margin-bottom: 100px;
}
.ach-card-bg-white {
  box-shadow: 0px 2px 20px 0px rgba(49, 65, 88, 0.1);
  border: 1px solid rgba(226, 232, 240, 1);
  padding: 20px 24px;
  border-radius: 32px;
  height: 100%;
}

.ach-card {
  background: linear-gradient(135deg, #00363f 0%, #015764 50%, #007586 100%);
  border-radius: 16px;
  padding: 24px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 54, 63, 0.3);
}

.ach-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ach-card .card-header h2 {
  font-size: 16px;
  font-weight: 500;
  opacity: 0.9;
}

.ach-card .card-header .icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ach-card .card-body .values {
  margin-bottom: 16px;
}

.ach-card .card-body .values span p {
  font-size: 50px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}

.ach-card .card-body .persentage {
  gap: 8px;
}

.ach-card .card-body .persentage span {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.8;
}

@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.consignment-card {
  box-shadow: 0px 2px 20px 0px #3141581a;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
}

.chart {
  width: 100%;
  height: 260px;
}

.legend-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 30px;
  margin-top: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #0f172a;
}

.legend-item .dot {
  width: 14.22px;
  height: 14.22px;
  border-radius: 50%;
}

.legend-item .value {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  color: rgba(89, 106, 109, 1);
}
</style>
